export interface MarketShareScopeTypeFilter {
  id: string
  name: string
}

export const MarketShareScopeTypeFilterAll: string = 'all'
